export default "__VITE_ASSET__DMyfWpoJ__"